<template>
  <div class="home">
    <nav class="navbar navbar-expand-lg navbar-light">
      <div>
        <a class="navbar-brand m-xs-auto" href="#">
        <img
          src="../assets/images/NovigoLogo.png"
          width="auto"
          height="35"
          class="d-inline-block align-top"
          alt=""
          style="background: white; border-radius: 5px; padding: 4px"
        />
        <!-- <h5 class="d-none d-sm-inline ml-2" style="line-height: 1.8">
          Identity Portal Management
        </h5> -->
        </a>
      <button class="dashboard-icon" @click="openSideBar">
        <i class="fas fa-bars"></i>
      </button>
      
      </div>
      <button
        class="navbar-toggler"
        type="button"
        data-toggle="collapse"
        data-target="#navbarTogglerDemo02"
        aria-controls="navbarTogglerDemo02"
        aria-expanded="false"
        aria-label="Toggle navigation"
      >
        <span class="navbar-toggler-icon"></span>
      </button>

      <div class="collapse navbar-collapse" id="navbarTogglerDemo02">
        <ul class="navbar-nav ml-auto mt-2 mt-lg-0 my-lg-0">
          <!-- <li class="nav-item active">
            <router-link class="nav-link" to="/home/">Home</router-link>
          </li> -->

          <li class="nav-item active">
            <!--<router-link class="nav-link" @click.native="logout" to="/"
              >Log Out <i class="fas fa-sign-out-alt"></i>
            </router-link> -->
            <button
              class="btn bg-transparent text-black btn-submit d-block"
              @click="signOut"
            >
              Logout <i class="fas fa-sign-out-alt"></i>
            </button>
          </li>

          <!-- <li class="nav-item dropdown">
            <a
              class="nav-link dropdown-toggle"
              href="#"
              id="navbarDropdown"
              role="button"
              data-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
            >
              Account
            </a>
            <div class="dropdown-menu" aria-labelledby="navbarDropdown">
              <a class="dropdown-item" href="#">Settings</a>
              <div class="dropdown-divider"></div>
              <a class="dropdown-item" href="#">Log Out</a>
            </div>
          </li> -->
        </ul>
      </div>
    </nav>

    <div class="container-fluid">
      <div class="row" style="flex-wrap: nowrap">
        <div
          class="dashboard "
          style="width: 250px"
          id="mySidebar"
        >
          <!-- <button class="dash-item" @click="openSideBar">Close &times;</button> -->
          <h5> Identity Pool</h5>
          <dropdownlist
            :data-items="identityPools"
            :text-field="'name'"
            :data-item-key="'id'"
            :default-value="identityPools[0]"
            @change="onSelectIdentity"
            style="width:10.4em"
          >
          </dropdownlist>   
          <i class="fa fa-plus ml-3" aria-hidden="true" @click="insert"></i>
          <dialog-container
            v-if="identityInEdit"
            :data-item="identityInEdit"
            @save="save"
            @cancel="cancel"
          >
      </dialog-container>
          
          <ul class="nav d-block">
            <li class="nav-item">
              <router-link class="nav-link text-truncate" to="/home/"
                ><i class="fa fa-home"></i>
                <span class="d-block d-md-inline">Home</span></router-link
              >
            </li>
            <li class="nav-item">
              <a
                class="nav-link collapsed text-truncate"
                href="#submenu2"
                data-toggle="collapse"
                data-target="#submenu2"
                ><i class="fas fa-user-circle"></i>
                <span
                  ><router-link
                    class="nav-link d-block d-md-inline p-0"
                    to="/home/view-clients"
                    >Client 
                  </router-link></span
                ></a
              >
            </li>
            <li class="nav-item">
              <a
                class="nav-link collapsed text-truncate"
                href="#submenu3"
                data-toggle="collapse"
                data-target="#submenu3"
                ><i class="fas fa-id-card"></i>
                <span
                  ><router-link
                    class="nav-link d-block d-md-inline p-0"
                    to="/home/view-tenants"
                    >
                     Tenants 
                  </router-link>
                </span>
              </a> 
            </li>
            <li class="nav-item">
              <a
                class="nav-link collapsed text-truncate"
                href="#submenu4"
                data-toggle="collapse"
                data-target="#submenu4"
                ><i class="fas fa-users"></i>
                <span
                  ><a class="nav-link d-block d-md-inline p-0" to=""
                    >User 
                  </a></span
                ></a
              >
              <div class="collapse" id="submenu4" aria-expanded="false">
                <ul class="flex-column pl-4 nav">
                  <li class="nav-item">
                    <a href="#">
                      <router-link class="nav-link" to="/home/view-users"
                        ><i class="fas fa-user-plus"></i>
                        Add User
                      </router-link></a
                    >
                  </li>
                  <li class="nav-item">
                    <a href="#">
                      <router-link class="nav-link" to="/home/user-claims">
                        <i class="fas fa-user"></i> User Claims
                      </router-link></a
                    >
                  </li>
                </ul>
              </div>
            </li>
            <li class="nav-item">
              <a
                class="nav-link collapsed text-truncate"
                href="#submenu5"
                data-toggle="collapse"
                data-target="#submenu5"
                ><i class="fa fa-table"></i>
                <span
                  ><a class="nav-link d-block d-md-inline p-0" to=""
                    >Role 
                  </a></span
                ></a
              >
              <div class="collapse" id="submenu5" aria-expanded="false">
                <ul class="flex-column pl-4 nav">
                  <li class="nav-item">
                    <a href="#"
                      ><router-link class="nav-link" to="/home/view-roles"
                        ><i class="fas fa-plus"></i>Add Roles
                      </router-link></a
                    >
                  </li>
                  <li class="nav-item">
                    <a href="#"
                      ><router-link class="nav-link" to="/home/role-claims"
                        ><i class="fas fa-link"></i>Role Claims
                      </router-link></a
                    >
                  </li>
                </ul>
              </div>
            </li>
            
            <li class="nav-item">
              <a
                class="nav-link collapsed text-truncate"
                href="#submenu6"
                data-toggle="collapse"
                data-target="#submenu6"
                ><i class="fas fa-envelope"></i>
                <span
                  ><a class="nav-link d-block d-md-inline p-0" to=""
                    >External Auth Provider 
                  </a></span
                ></a
              >
              <div class="collapse" id="submenu6" aria-expanded="false">
                <ul class="flex-column pl-4 nav">
                  <li class="nav-item">
                    <a href="#"
                      ><router-link class="nav-link" to="/home/external-providers">
                  <i class="fas fa-plus"></i>External Providers</router-link>
                      </a
                    >
                  </li><li class="nav-item">
                    <a href="#"
                      ><router-link class="nav-link" to="/home/tenant-external-providers">
                  <i class="fas fa-plus"></i>Tenant External Providers</router-link>
                      </a
                    >
                  </li>
                </ul>
              </div>
            </li>
          </ul>
        </div>

        <div class="col px-0 mt-2 content">
          <div class="panel panel-default">
            <router-view :identity="selectedIdentity" @refresh="refresh"/>
          </div>
        </div>
      </div>
    </div>

    <footer class="pull-left footer">
      <hr class="divider" />
      Copyright &COPY; 2020
      <a href="http://www.novigosolutions.com">Novigo Solutions</a>
    </footer>
  </div>
</template>
<style >
.dashboard-icon {
  background: transparent;
  padding: 5px;
  border: none;
  outline: none;
  font-size: 20px;
  color: #777;
}
.dashboard-icon:focus{
  outline: none;
}

.dashboard-icon:hover{
  color: black;
}
.navbar {
  background: #fff;
  border-bottom: 1px solid #e0e4e9;
  border-radius: 0 0 5px 5px;
}
.sidebar-button {
  color: rgba(0, 0, 0, 0.5);
  border-color: rgba(0, 0, 0, 0.1);
  padding: 0.25rem 0.75rem;
  font-size: 0.75rem;
  line-height: 1;
  background-color: transparent;
  border-radius: 0.25rem;
}
.navbar-toggler {
  font-size: 0.75rem;
}
.dashboard {
  height: 80vh;
  width: 200px;
  background-color: #fff;
  position: relative;
  z-index: 1;
  overflow: auto;
  display: none;
  padding: 8px 16px;
  text-align: left;
  border-right:1px solid #e0e4e9;
  white-space: normal;
  float: none;
  outline: 0;
  animation: animateleft 0.4s;
}
@keyframes animateleft {
  from {
    left: -300px;
    opacity: 0;
  }
  to {
    left: 0;
    opacity: 1;
  }
}
.dash-item {
  padding: 8px 16px;
  float: left;
  width: auto;
  border: none;
  display: block;
  outline: 0;
  font-size: 1rem;
  width: 100%;
}
.fa,
.fas {
  padding-right: 0.75rem;
}
.nav-link {
  color:rgba(0,0,0,.7);
  font-weight: 500;
  white-space: normal;
  word-break: break-word;
}
.k-widget.k-dialog {
    overflow: auto;
}

@media only screen and (max-width: 1024px) {
  .dashboard{
    position:fixed;
    z-index: 99;
  }
  
}
</style>
<script>
// @ is an alias to /src
import Home from "@/components/Home.vue";
import { mapActions } from "vuex";
import axios from "axios";
import { DropDownList } from "@progress/kendo-vue-dropdowns";
import { oidcSettings } from "../services/store";
import DialogContainer from "../components/AddIdentityPool";

export default {
  name: "home",
  components: {
    Home,   
    dropdownlist: DropDownList,    
    "dialog-container": DialogContainer,

  },
  data: function () {
    return {
      base_url: undefined,
      identityPools: [],
      selectedIdentity: undefined,
      identityInEdit: undefined,
      }
    },
  mounted: function () {
    this.base_url = oidcSettings.authority + "/api/IdentityManagement/";

    this.getIdentityPools();
  },
  methods: {
    insert:function (){
      this.identityInEdit={}
    },
    refresh(){
      this.getIdentityPools();
    },
    async save() {
      const dataItem = this.identityInEdit;
      const identityPools = this.identityPools.slice();
        const client_id = oidcSettings.client_id;
      let data = {
        name: dataItem.name,
      };
      try {
        const response = await axios
          .post(this.base_url + "IdentityPool/AddIdentityPool/"+dataItem.name)
          .then((response) => {
            var newObject = response.data.result;
            identityPools.push(newObject);
          });
                //      this.getIdentity();
      } catch (err) {
        console.log("Ooops!" + err);
      }

      this.identityPools = identityPools;
      this.identityInEdit = undefined;
    },

    cancel() {
      this.identityInEdit = undefined;
    },
    onSelectIdentity(event) {
      console.log("change", event.target.value);
      this.selectedIdentity = event.target.value;
    },
    async getIdentityPools() {
      try {
        const response = await axios.get(
          this.base_url + "IdentityPool/GetIdentityPools"
        );
        this.identityPools = response.data.result;
        this.selectedIdentity=this.identityPools[0];
      } catch (err) {
        console.log(err);
      }
    },
    ...mapActions(["authenticateOidcPopup", "signOutOidcSilent"]),
    openSideBar() {
      if (document.getElementById("mySidebar").style.display == "block") {
        document.getElementById("mySidebar").style.display = "none";
      } else {
        document.getElementById("mySidebar").style.display = "block";
      }
    },
    signOut: function () {
      this.signOutOidcSilent().then((response) => {
        this.$router.push("/logoutSuccess");
      });
    },
  },
};
</script>
<style scoped>
.fa:hover{
  color:cadetblue;
  cursor: pointer;
}
</style>